import { dontLoginFetch, apiFetch } from "../fetchConfig";

export interface UserOutPut {
    userId: number;
    loginId: string;
    userNm: string;
    email: string;
    roleId: number;
    roleNm: string;
    priorityLevel: number;
    status: number;
    message: string;
}

export interface ReIssuanceDto {
    status: number;
    message: string;
    token: string;
}

export interface PasswordResetDto {
    status: number;
    message: string;
}

export interface BranchManagerLoginRequest {
    userId: string;
    userPwd: string;
    compCd: string;
}

export interface LoginOutput {
    status: number;
    message: string;
    site?: string;
    compCd?: string;
    id?: number;
    loginId?: string;
    userNm?: string;
    email?: string;
    roleId?: number;
    roleNm?: string;
    priorityLevel?: number;
}

export interface CompCdWithCompanyName {
    compCd: string;
    companyName?: string;
}

const initialAddress = "/api/auth"

export const signIn = async (req): Promise<UserOutPut> => {
    try {
        const data = await dontLoginFetch.post(`${initialAddress}/login`, req)
        return data.json();
    } catch (error) {
        throw error;
    }
}

export const reIssuanceAccessToken = async (): Promise<ReIssuanceDto> => {
    try {
        const data = await dontLoginFetch.post(`${initialAddress}/re-issuance`)
        return data.json();
    } catch (error) {
        throw error;
    }
}

export const signOut = async (): Promise<ReIssuanceDto> => {
    try {
        const data = await dontLoginFetch.post(`${initialAddress}/logout`)
        return data.json();
    } catch (error) {
        throw error;
    }
}

export const resetPasswordByUserInfo = async (req): Promise<PasswordResetDto> => {
    try {
        const data = await dontLoginFetch.post(`${initialAddress}/reset-password`, req);
        return data.json();
    } catch (error) {
        throw error;
    }
};

// 지부장 로그인
export const loginForBranchManager = async (req: BranchManagerLoginRequest): Promise<LoginOutput> => {
    try {
        const data = await dontLoginFetch.post(`${initialAddress}/login/bm`, req);
        return data.json();
    } catch (error) {
        throw error;
    }
};

// 지부장 로그인 유효성 검사
export const loginValidForBranchManager = async (clientId: string, pwd: string): Promise<boolean> => {
    try {
        const data = await dontLoginFetch.get(`${initialAddress}/login/bm?clientId=${encodeURIComponent(clientId)}&pwd=${encodeURIComponent(pwd)}`);
        return data.json();
    } catch (error) {
        throw error;
    }
};

// 소속 설정
export const setAffiliation = async (compCd: string): Promise<LoginOutput> => {
    try {
        const data = await apiFetch.patch(`/api/login/bm?compCd=${encodeURIComponent(compCd)}`);
        return data.json();
    } catch (error) {
        throw error;
    }
};

// 사이트별 회사 코드와 이름 조회 (REST)
export const getCompCdWithNameBySite = async (clientId: string): Promise<CompCdWithCompanyName[]> => {
    try {
        const response = await dontLoginFetch.get(`${initialAddress}/login/comp?clientId=${encodeURIComponent(clientId)}`);
        return await response.json();
    } catch (error) {
        throw error;
    }
};